/* 🤖 this file was generated by svg-to-ts */
export const DfIconEnvelope16: {
  name: 'envelope-16';
  data: string;
} = {
  name: 'envelope-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15.828 3.188 9.103 7.644a1.997 1.997 0 0 1-2.206 0L.172 3.188A2 2 0 0 1 2 2h12a2 2 0 0 1 1.828 1.188zM16 5.127V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.127l6.902 4.544c.666.439 1.53.439 2.196 0z" fill-rule="evenodd"/></svg>`
};
